import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
  Button,
  Card,
  CardHeader,
  CardTitle,
} from '@clouway/ui'
import { ArrowLeftRight } from 'lucide-react'

import type { Customer } from '@/features/customers'

export function MoveTargetCard({
  customer,
  lpn,
  onMove,
}: {
  customer: Customer
  lpn: string
  onMove: (customer: Customer) => void
}) {
  const { t } = useTranslation('feature')
  const { t: tCommon } = useTranslation('common')

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between gap-2">
          <div>
            <CardTitle className="text-sm">{customer.name}</CardTitle>
            {customer.taxId && <p className="text-muted-foreground text-sm">{customer.taxId}</p>}
          </div>
          <AlertDialog>
            <AlertDialogTrigger asChild>
              <Button variant="outline" size="sm">
                <ArrowLeftRight className="size-4" />
                {tCommon('ui.button.move')}
              </Button>
            </AlertDialogTrigger>
            <AlertDialogContent>
              <AlertDialogHeader>
                <AlertDialogTitle>
                  {t('trackingObjects.move.confirmTitle')} {lpn}
                </AlertDialogTitle>
                <AlertDialogDescription>
                  {t('trackingObjects.move.confirmContent')}: {customer.name}
                </AlertDialogDescription>
              </AlertDialogHeader>
              <AlertDialogFooter>
                <AlertDialogCancel>{tCommon('ui.button.cancel')}</AlertDialogCancel>
                <AlertDialogAction onClick={() => onMove(customer)}>{tCommon('ui.button.move')}</AlertDialogAction>
              </AlertDialogFooter>
            </AlertDialogContent>
          </AlertDialog>
        </div>
      </CardHeader>
    </Card>
  )
}
